import React from 'react'
import { FlexRow, FlexColumn, LinkButton, Text, Image } from 'elements'
import IntegrationStatus from './IntegrationStatus'

const headerColors = {
  disabled: 'neutral.1',
  enabled: 'primary.0',
  error: 'danger.0',
}

const BUTTON_LABELS = {
  disabled: 'Reconnect',
  error: 'Try again',
  enabled: 'Disconnect',
}

export default function IntegrationBox({
  userIntegration,
  logo,
  logoWidth = '100%',
  onConfigure,
  onDelete,
  onConnect,
}) {
  const status = userIntegration?.status?.toLowerCase()

  return (
    <FlexColumn width="265px" height="200px">
      <FlexRow
        px="large"
        py="medium"
        borderRadius="9px 9px 0 0"
        bg={headerColors[status] || 'neutral.1'}
      >
        <IntegrationStatus status={status} userIntegration={userIntegration} />
      </FlexRow>
      <FlexColumn
        flex="1"
        border="2px solid"
        borderTop="none"
        borderColor="neutral.2"
        borderRadius="0 0 9px 9px"
      >
        <FlexRow flex="1" alignItems="center" justifyContent="center" px="xxlarge" py="large">
          <Image width={logoWidth} src={logo} />
        </FlexRow>
        <FlexRow
          px="large"
          py="medium"
          borderTop="2px solid"
          borderColor="neutral.2"
          justifyContent="space-between"
        >
          {status === 'enabled' ? (
            <>
              <LinkButton onClick={onDelete}>
                <Text fontSize="small" color="neutral.3">
                  Disconnect
                </Text>
              </LinkButton>

              {onConfigure ? (
                <LinkButton onClick={onConfigure}>
                  <Text fontSize="small" color="primary.0">
                    Configure
                  </Text>
                </LinkButton>
              ) : null}
            </>
          ) : (
            <LinkButton mx="auto" onClick={onConnect}>
              <Text fontSize="small" color="primary.0">
                {BUTTON_LABELS[status] || 'Connect'}
              </Text>
            </LinkButton>
          )}
        </FlexRow>
      </FlexColumn>
    </FlexColumn>
  )
}
